import React from 'react';
import { Box, Typography, Breadcrumbs, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function HeaderBreadcrumbs({ heading, links = [], action, sx, ...other }) {
  return (
    <Box sx={{ mb: 3, ...sx }} {...other}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box>
          <Typography variant="h4" gutterBottom>
            {heading}
          </Typography>
          {links.length > 0 && (
            <Breadcrumbs aria-label="breadcrumb">
              {links.map((link, index) => {
                const isLast = index === links.length - 1;
                return isLast ? (
                  <Typography key={link.name} color="text.primary">
                    {link.name}
                  </Typography>
                ) : (
                  <Link
                    key={link.name}
                    component={RouterLink}
                    to={link.href}
                    color="inherit"
                    underline="hover"
                  >
                    {link.name}
                  </Link>
                );
              })}
            </Breadcrumbs>
          )}
        </Box>
        {action && <Box>{action}</Box>}
      </Box>
    </Box>
  );
}
